import { generateAsapHeader } from '@atlassiansox/asc-asap';
import { mapResponseToJson } from '@atlassiansox/asc-core';
import { fetch, Headers } from 'cross-fetch';
import {
  CloudNameAvailabilityRequest,
  CloudNameAvailabilityResponse,
  GetNameAvailabilityRequest,
  GetNameAvailabilityResponse
} from './cnas-client.types';

export const STAGING_BASE_URL =
  'https://wac.stg.internal.atlassian.com/apis/stg/cnas';
export const PRODUCTION_BASE_URL = 'https://www.atlassian.com/apis/prod/cnas';
export const ASAP_AUDIENCE = 'cloud-name-availability';

export type CnasClientOptions = {
  readonly baseUrl?: string;
};

export interface ICnasClient {
  getNameAvailability: ({
    cloudName
  }: GetNameAvailabilityRequest) => Promise<GetNameAvailabilityResponse>;
  cloudNameAvailabilityCheck: ({
    cloudName,
    auth
  }: CloudNameAvailabilityRequest) => Promise<CloudNameAvailabilityResponse>;
}

export class CnasClient implements ICnasClient {
  private readonly baseUrl: string;

  public constructor({ baseUrl = STAGING_BASE_URL }: CnasClientOptions = {}) {
    this.baseUrl = baseUrl;
  }

  public async getNameAvailability({
    cloudName
  }: GetNameAvailabilityRequest): Promise<GetNameAvailabilityResponse> {
    return mapResponseToJson(
      await fetch(`${this.baseUrl}/shopping-cart/name-availability/queries`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cloudName
        })
      })
    );
  }

  public async cloudNameAvailabilityCheck({
    cloudName,
    auth
  }: CloudNameAvailabilityRequest): Promise<CloudNameAvailabilityResponse> {
    const headers = new Headers();

    headers.append('Content-Type', 'application/json');
    headers.append(
      'Authorization',
      generateAsapHeader({
        ...auth.asap,
        audience: ASAP_AUDIENCE
      })
    );
    return mapResponseToJson(
      await fetch(`${this.baseUrl}/name-availability/check`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          cloudName
        })
      })
    );
  }
}
